import { AreaCode } from '@enechain/eposition-proto/bfftypes/v1/area_pb'
import {
  DealPosition,
  DeliveryHourType,
  DeliveryPeriodType,
  DeliveryType,
} from '@enechain/eposition-proto/types/v1/deal_pb'

import {
  LooseTransactionSchema,
  OrderPatternSchema,
  OrderSimulationSchema,
} from '../schemas'

export const INITIAL_TRANSACTION_FORM: LooseTransactionSchema = {
  areaCode: AreaCode.UNSPECIFIED,
  deliveryPeriodType: DeliveryPeriodType.MONTH,
  deliveryDateRange: {
    deliveryStartDate: undefined,
    deliveryEndDate: undefined,
  },
  deliveryHourType: DeliveryHourType.UNSPECIFIED,
  unitPricePerKwh: undefined,
  volumeInKw: undefined,
}

export const INITIAL_ORDER_PATTERN_FORM: OrderPatternSchema = {
  dealPosition: DealPosition.BID,
  isPhysicalFuture: true,
  selfDeliveryType: DeliveryType.JEPX,
  eClearDeliveryType: DeliveryType.EEX,
  spreadType: {
    isSpreadTrade: false,
    spreadType: [],
    diffUnitPrice: '',
  },
  baseSummaryOrder: INITIAL_TRANSACTION_FORM,
  exchangeSummaryOrder: undefined,
  baseTransactions: [],
  exchangeTransactions: [],
}

export const INITIAL_SIMULATION_FORM: OrderSimulationSchema = {
  marginSimulationRelation: [],
  availableDealSimulationRelation: [],
  orderPattern: [],
}
